import { StoredItem } from "LibMargoWorld/item";

import { ExtendedItemInfo } from "./extended-info";

function findExtendedInfoTargets(el?: HTMLElement): HTMLElement[] {
    return Array.from((el ?? document).querySelectorAll(".extended-item-info"));
}

function findAssociatedItem(el: HTMLElement) {
    const itEl = <HTMLElement>document.querySelector(`[data-item-id="${el.dataset.targetItem}"]`);
    if (!itEl) {
        console.error(`extended-info-loader: target item not found for element:`, el);
        return null;
    } else {
        const itJson = itEl.dataset.item ?? itEl.dataset.itemtip;
        try {
            return <StoredItem>JSON.parse(itJson);
        } catch (e) {
            console.error(`extended-item-loader: item data not found or malformed for: `, el, e);
        }
    }
}

export function initExtendedItemInfo(parent?: HTMLElement) {
    const els = findExtendedInfoTargets(parent);
    for (const el of els) {
        const it = findAssociatedItem(el);
        if (it) {
            new ExtendedItemInfo(el, it);
        }
    }
    ExtendedItemInfo.globalInit();
}
